<template>
  <div class="play" :title="playMsg.title">
    <a-player
      ref="playDom"
      :music="{
      title: playMsg.productionName,
  artist: ' ',
  lrc: playMsg.wordsUrl,
  src: playMsg.sourceUrl,
  pic: playMsg.coverUrl
    }"
      @pause="pause()"
      @playing="play()"
    ></a-player>
    <div class="state" v-if="playMsg.isAudit==0">
      <img src="../assets/image/shz.png" alt />
    </div>
    <div class="state" v-else-if="playMsg.isAudit==1">
      <img src="../assets/image/tg.png" alt />
    </div>
    <div class="state" v-else>
      <img src="../assets/image/btg.png" alt />
    </div>
  </div>
</template>

<script>
import VueAplayer from "vue-aplayer";
export default {
  components: {
    "a-player": VueAplayer,
  },
  name: "player",
  props: {
    playMsg: Object,
    required: true,
  },
  created() {},
  methods: {
    pause() {
      this.$refs.playDom.$el.children[0].style.background = "rgba(0,0,0,0.5)";
    },
    play() {
      this.$refs.playDom.$el.children[0].style.background = "rgba(0,0,0,0)";
    },
  },
};
</script>

<style scoped lang="scss">
.play {
  width: 246px;
  height: 292px;
  margin: 22px 15px 0px 20px;
  position: relative;
  .aplayer {
    width: 240px;
    height: 242px;
    margin: 0;
    border: 2px solid #a3f310;
    /*background:url(../assets/image/bg4.jpg) no-repeat 0 0;*/
    overflow: inherit;
  }
  .state {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
<style lang="scss">
.play {
  .aplayer-body {
    height: 100%;
    overflow: inherit;
    background: rgba(0, 0, 0, 0.5);
  }
  .aplayer-pic {
    background-color: transparent !important;
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: inherit;
  }
  .aplayer-info {
    position: absolute;
    bottom: 5px;
    width: 100%;
    height: 30px !important;
    overflow: inherit !important;
  }
  .inactive {
    display: none !important;
  }
  /*.aplayer-controller .aplayer-time{*/
  /*margin-right: 20px;*/
  /*}*/
  .aplayer-bar-wrap .aplayer-bar {
    /*position: absolute;*/
    height: 2px;
    background: #cdcdcd;
  }
  .aplayer-music {
    position: absolute;
    bottom: -55px;
    color: #fff;
    left: 0;
    height: 40px;
    margin-left: 0 !important;
    overflow: inherit !important;
    width: 240px !important;
    white-space: normal !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
  }
  .aplayer-author {
    color: #fff !important;
  }
  .aplayer-pic .aplayer-play {
    width: 40px;
    height: 40px;
    border: 2px solid #fff;
    bottom: 50%;
    right: 48%;
    margin: 0 -15px -15px 0;
  }
  .aplayer-pic .aplayer-pause {
    width: 40px;
    height: 40px;
    border: 2px solid #fff;
    bottom: 50%;
    right: 48%;
    margin: 0 -15px -15px 0;
  }
  .aplayer-pic .aplayer-pause .aplayer-icon-pause {
    position: absolute;
    top: 3px;
    left: 2px;
    height: 35px;
    width: 35px;
  }
  .aplayer-pic .aplayer-play .aplayer-icon-play {
    position: absolute;
    top: 3px;
    left: 4px;
    height: 35px;
    width: 35px;
  }
  .aplayer-played {
    background: #a3f310 !important;
  }
  .aplayer-thumb {
    border-color: #a3f310 !important;
    background-color: #a3f310 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/play.vue